import { createAction, createReducer } from 'redux-starter-kit'
import { createSelector } from 'reselect'

export const SET_EDUCATION_JOYRIDES_SUCCESS =
  '[educationJoyrides] set education joyrides success'
export const STORE_EDUCATION_JOYRIDES_REQUEST =
  '[educationJoyrides] store education joyrides request'
export const STORE_EDUCATION_JOYRIDES_SUCCESS =
  '[educationJoyrides] store education joyrides success'
export const STORE_EDUCATION_JOYRIDES_FAILURE =
  '[educationJoyrides] store education joyrides failure'

const initialState = {
  tracks: {},
  // True once the user's EDUCATION_JOYRIDES context has been fetched, so an
  // empty `tracks` can be told apart from "not loaded yet".
  loaded: false,
  loading: false,
  error: null,
}

export const storeEducationJoyridesAction = createAction(
  STORE_EDUCATION_JOYRIDES_REQUEST
)

const reducer = createReducer(initialState, {
  [SET_EDUCATION_JOYRIDES_SUCCESS]: (state, { payload }) => {
    state.tracks = payload?.tracks ?? {}
    state.loaded = true
    state.loading = false
    state.error = null
  },
  [STORE_EDUCATION_JOYRIDES_REQUEST]: (state) => {
    state.loading = true
  },
  [STORE_EDUCATION_JOYRIDES_SUCCESS]: (state, { payload }) => {
    state.tracks = payload?.tracks ?? {}
    state.loading = false
    state.error = null
  },
  [STORE_EDUCATION_JOYRIDES_FAILURE]: (state, { payload }) => {
    state.loading = false
    state.error = payload
  },
})

const stateSelector = (state) => state.educationJoyrides

export const educationJoyridesTracksSelector = createSelector(
  stateSelector,
  (state) => state?.tracks ?? {}
)

export const educationJoyridesLoadedSelector = createSelector(
  stateSelector,
  (state) => !!state?.loaded
)

export const educationJoyridesLoadingSelector = createSelector(
  stateSelector,
  (state) => state?.loading ?? false
)

export default reducer
